import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ParticipantCard from './ParticipantCard';
import SubjectCard from './SubjectCard';

const propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
  }),
  customer: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
  }).isRequired,
  subject: PropTypes.shape({
    subjectName: PropTypes.string,
    policyId: PropTypes.string,
    gender: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
  }),
  assignedToGroup: PropTypes.bool,
  providerGroupSpecialty: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  serviceName: PropTypes.string,
  permissions: PropTypes.shape({
    canSeeProvider: PropTypes.bool.isRequired,
    canSeeCustomer: PropTypes.bool.isRequired,
    canSeeSubjects: PropTypes.bool.isRequired,
  }).isRequired,
};

const defaultProps = {
  subject: null,
  provider: null,
  assignedToGroup: false,
  serviceName: null,
  providerGroupSpecialty: null,
};

const AppointmentParticipantsInfo = ({
  provider,
  assignedToGroup,
  customer,
  subject,
  serviceName,
  providerGroupSpecialty,
  permissions,
}) => {
  return (
    <Fragment>
      <ParticipantCard { ...{
            ...provider,
            assignedToGroup,
            serviceName,
            providerGroupSpecialty,
            isMasked: !permissions.canSeeProvider,
          }
        }
      />
      <ParticipantCard { ...{ ...customer, isMasked: !permissions.canSeeCustomer } } />

      <SubjectCard { ...{ ...subject, isMasked: !permissions.canSeeSubjects } } />
    </Fragment>
  );
};

AppointmentParticipantsInfo.propTypes = propTypes;
AppointmentParticipantsInfo.defaultProps = defaultProps;

export default AppointmentParticipantsInfo;
